import React, { useContext } from "react";
import { AuthContext } from "../../contexts/AuthContext";
import Header from "../../layout/Header/Header";
import { MenuCard, MenuHeader } from "../../MenuCard";

const ITEMS = [
  { label: "Compras",      icon: "fas fa-shopping-cart",       color: "#3b82f6", bg: "#eff6ff", href: "/DashboardCompras",    desc: "Dashboard de compras",       perm: "menu_reportes" },
  { label: "CXP",          icon: "fas fa-file-invoice",        color: "#6366f1", bg: "#eef2ff", href: "/DashboardCXP",        desc: "Cuentas por pagar",          perm: "menu_reportes" },
  { label: "Inventarios",  icon: "fas fa-boxes",               color: "#10b981", bg: "#f0fdf4", href: "/DashboardInventarios",desc: "Estado del inventario",      perm: "menu_reportes" },
  { label: "Ventas",       icon: "fas fa-cash-register",       color: "#f59e0b", bg: "#fffbeb", href: "/DashboardVentas",     desc: "Métricas de ventas",         perm: "menu_reportes" },
  { label: "Cobranza",     icon: "fas fa-hand-holding-usd",    color: "#0ea5e9", bg: "#f0f9ff", href: "/DashboardCobranza",   desc: "Estado de cobranza",         perm: "menu_reportes" },
  { label: "Tiendas",      icon: "fas fa-store",               color: "#8b5cf6", bg: "#f5f3ff", href: "/DashboardTiendas",    desc: "Dashboard tiendas",          perm: "menu_reportes" },
  { label: "Gastos",       icon: "fas fa-wallet",              color: "#f97316", bg: "#fff7ed", href: "/DashboardGastos",     desc: "Análisis de gastos",         perm: "menu_reportes" },
  { label: "Balance",      icon: "fas fa-balance-scale",       color: "#64748b", bg: "#f8fafc", href: "/Balance",             desc: "Balance general",            perm: "menu_reportes" },
];

function BotonesDashboards() {
  const { user } = useContext(AuthContext);
  return (
    <>
      <Header />
      <div className="card container">
        <MenuHeader icon="fas fa-tachometer-alt" color="#8b5cf6" bg="#f5f3ff" title="Dashboards" subtitle="Tableros de control ejecutivos" />
        {user.menu_reportes ? (
          <div className="row">
            {ITEMS.map((r, i) => <MenuCard key={i} {...r} enabled={!!user[r.perm]} />)}
          </div>
        ) : <p style={{ color: "#94a3b8", fontSize: "0.82rem" }}>Sin acceso.</p>}
      </div>
    </>
  );
}

export default BotonesDashboards;
